<template>
  <div class="homepage-hero-module">
    <div class="co-logo"></div>
    <div class="login-frame">
      <i class="lt"></i>
      <i class="rt"></i>
      <i class="lb"></i>
      <i class="rb"></i>
      <div class="login-title">Octopus<br/>三维可视化运维系统</div>
      <div class="lg-pwd-frame">
        <div class="lg-title">{{$t("home.signIn")}}</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label-width="0" prop="loginName">
            <el-input class="iconfont log-input" prefix-icon="el-icon-user" v-model="ruleForm.loginName" :placeholder='$t("home.userName")'></el-input>
          </el-form-item>
          <el-form-item label-width="0" style="margin:0" prop="loginPwd">
            <el-input type="password" class="iconfont log-input" prefix-icon="el-icon-lock" v-model="ruleForm.loginPwd" :placeholder='$t("home.password")'></el-input>
          </el-form-item>

          <div class="error-msg" v-show="isError">
            <div class="error-msg alignItemsCenter">
              <el-alert v-bind:title="msg" type="error" :closable="false" show-icon></el-alert>
            </div>
          </div>
          <div class="bot-btn">
            <div>
              <el-checkbox @change="rememberUser" v-model="rememberPwd">{{$t("home.remPass")}}</el-checkbox>
            </div>
          </div>
          <div>
            <el-button type="primary" class="login-button" @click="login">{{$t("home.signIn")}}</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <div class="foot">
      <div class="l-foot">
        Copyright     2020  沪ICP备05014369号  沪公网安备31010602001957号  
      </div>
      <div class="r-foot">
        <p>使用条款</p>
        <p>法律声明</p>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
import JSEncryptUtil from '../../common/js/jSEncryptUtil.js'
export default {
  name: 'Login',
  data() {
    return {
      msg: '',
      isError: false,
      ruleForm: {
        token: '',
        loginName: '',
        loginPwd: ''
      },
      rememberPwd: false,
      rules: {
        loginName: [
          {
            required: true,
            message: this.$t('home.userName'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 18,
            message: this.$t('home.passTipLength'),
            trigger: 'blur'
          }
        ],
        loginPwd: [
          {
            required: true,
            message: this.$t('home.password'),
            trigger: 'blur'
          },
          {
            min: 4,
            max: 18,
            message: this.$t('home.passTipLength2'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    let that = this
    sessionStorage.clear()
    document.onkeydown = function(e) {
      var key = window.event.keyCode
      if (key == 13) {
        that.login()
      }
    }
    if (that.$utils.getCookie('spcUser')) {
      that.rememberPwd = true
      that.ruleForm.loginName = that.$utils.getCookie('spcUser')
      that.ruleForm.loginPwd = that.$utils.getCookie('spcPwd')
    }
  },
  methods: {
    rememberUser(val) {
      if (!val) {
        this.$utils.delCookie('spcUser')
        this.$utils.delCookie('spcPwd')
      }
    },
    getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    testJSEncryptUtil() {
      const encryptor = JSEncryptUtil.init()
      const rsaPassWord = encryptor.encrypt('123456') // 对密码进行加密
    },
    getUserInfo(token) {
      ApiService.octopus_user
        .getUserInfo({
          token: token
        })
        .then(res => {
          localStorage.user = JSON.stringify(res.data.userEntity)
          // this.getSysNotice(res.data.userEntity.userId)
          window.location.href = '/mains.html'
        })
    },
    login() {
      // this.$router.push({
      //   path: '/main'
      // })
      // let isChecked = true
      // this.$refs['ruleForm'].validate(valid => {
      //   isChecked = valid
      // })
      // if (!isChecked) {
      //   return
      // }
      ApiService.user
        .loginOctopus({
          userAccount: this.ruleForm.loginName,
          password: this.ruleForm.loginPwd,
        })
        .then(res => {
          if (res.code === 0) {
            if (this.rememberPwd) {
              this.$utils.setCookie('spcUser', this.ruleForm.loginName)
              this.$utils.setCookie('spcPwd', this.ruleForm.loginPwd)
            }
            sessionStorage.setItem(
              'userName',
              this.$utils.encrypt(this.ruleForm.loginName)
            )
            sessionStorage.setItem(
              'userSign',
              this.$utils.encrypt(this.ruleForm.loginPwd)
            )
            localStorage.token = res.data.token
            sessionStorage.setItem('octopus_token', res.data.token)
            this.$utils.setCookie('token', res.data.token)
            this.getUserInfo(res.data.token)
          } else {
            this.ruleForm.loginPwd = ''
            this.msg = res.msg
            this.isError = true
          }
        })
    }
  }
}
</script>
<style lang='scss' scoped>
.login-frame {
  width: 410px;
  height: 420px;
  background: #fff;
  background-size: 400px 420px;
  position: absolute;
  border-radius: 4px;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 2;
  box-sizing: border-box;
  .login-title {
    position: absolute;
    top: -100px;
    width: 100%;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #fff;
  }
  .rt, .lt, .lb, .rb {
    display: block;
    height: 25px;
    width: 25px;
    border: 3px solid #F3B231;
    position: absolute;
  }
  .rt {
    top: 0;
    right: 0;
    border-left: 0;
    border-bottom: 0;
  }
  .lt {
    top: 0;
    left: 0;
    border-right: 0;
    border-bottom: 0;
  }
  .rb {
    right: 0;
    bottom: 0;
    border-left: 0;
    border-top: 0;
  }
  .lb {
    left: 0;
    bottom: 0;
    border-right: 0;
    border-top: 0;
  }
}

.login-frame .lg-pwd-frame {
  margin: 0 auto;
  padding: 33px;
}

.lg-pwd-frame .lg-title {
  font-size: 24px;
  color: #000;
  font-family: Microsoft YaHei Regular;
  border-bottom: 1px solid rgba(225, 228, 235, 0);
  padding-bottom: 13px;
  margin-bottom: 40px;
  margin-top: 15px;
  text-align: center;
}
.lg-pwd-frame {
  ::v-deep {
    .el-scrollbar__wrap {
      overflow: scroll !important;
      height: 100%  !important;
    }
  }
}

.bot-btn {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 30px;
  font-family: Microsoft YaHei Regular;
  font-size: 14px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.6);
  .el-checkbox {
    color: #000;
    font-family: Microsoft YaHei Regular;
    font-size: 14px;
    font-weight: 300;
  }
  div {
    cursor: pointer;
    &:last-child {
      color: #409eff;
      &:hover {
        color: #409eff;
      }
    }
  }
}

.el-icon-user {
  background: url(../../common/images/icon/user.png) no-repeat 50% 50% center;
  width: 20px;
  height: 20px;
}

.login-button {
  width: 100%;
  background: #0078d7;
  border-color: #0078d7;
  font-size: 16px;
  font-weight: 300;
}

.error-msg {
  width: 100%;
  height: 30px;
  margin-top: 10px;
}

.homepage-hero-module {
  position: relative;
  height: 100vh;
  overflow: hidden;
  background: url('./../../assets/images/login_bg.png') no-repeat center;
  background-size: cover;
  mix-blend-mode: soft-light;
  .foot {
    position: absolute;
    height: 45px;
    width: 100%;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #143a6f;
    color: rgba(255, 255, 255, 0.8);
    padding: 0 15px;
    font-size: 16px;
    box-sizing: border-box;
    .r-foot {
      font-size: 14px;
      display: flex;
      p:first-child {
        margin-right: 20px;
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/user/Login.vue